<template>
  <div class="login container">
    <div v-if="!redeemCardPermission()" class="pt-5">
      <h2>Sorry, you do not have permissions to access this feature.</h2>
    </div>
    <form v-else @submit.prevent="submit" class="d-flex justify-content-center flex-column align-items-center">


        <div class="d-flex justify-content-between w-100">
        <div class="col-xs-6 pl-3 pt-5">
          <cta link="redeem" shape="circle" icon="left-arrow" text="" margin="no-margin" />
        </div>
        <div class="col-xs-6  pr-3 pt-5">
            <cta type="submit" shape="circle" text="" icon="right-arrow" :disabled="!amount || errors.has('amount')" margin="no-margin" :loading="submitted" />
        </div>
        </div>

        <div class="row">
          <h2 class="col-md-12 pt-2">Enter redemption amount</h2>
        </div>

        <div class="row size-limit w-100">
            <currency-input :value="card.balance" :currency="card.Currency" class="col-md-12 pb-3" pt-2 v-model="amount" name="amount" v-validate="'min_value:1|max_value:'+card.balance"/>
        </div>
        



        <div class="row d-flex justify-content-center">
          <cta type="button" @click="amount = card.balance" text="Or redeem full amount" :class="{border : card.balance == amount}"   />
        </div>
        <div class="row d-flex justify-content-center">
          <h2 class="product_name pt-4">{{card.product_name}}</h2>
          </div>
          <div class="row d-flex justify-content-center">
          <p class="current_balance pt-3">Current card balance</p>
          </div>
          <div class="row d-flex justify-content-center">
          <h2 class="current_balance text-center pt-1 pb-3">{{getPriceDisplay(card.Currency,card.balance)}}</h2>
          </div>
        

      

    </form>
   
  </div>
</template>

<script>
export default {
  name: 'Login',
  inject: ['$validator'],
  data : function(){       
      return {
        amount:'',
        submitted:false
      };
  },
  computed: {
    card()
    {
        return this.$store.getters.getCard;
    },
    amountStore(){
        return this.$store.getters.getRedemptionAmount;
    }
  },
  created:function(){
    this.amount = this.amountStore;
    
  },
  methods:{
      /*
      * Login form submit handler
      */
      submit()
      {
        this.$validator.validateAll().then((result) => {
          if(result){
            this.$store.commit('SET_REDEMPTION_AMOUNT',Math.round(this.amount));
            this.$router.push({ name: 'redeem-confirmation'});
          }
        });
          
      },



     


  }
}
</script>

<style scoped>

  .current_balance{
    margin-top:0;    
    margin-bottom:0;    

  }

  

</style>
